<!-- CHUNK 1: Data and Configuration -->
console.log("✅ rug-customizer.js file is included!");

// Global variable to store the current organization key
let currentOrgKey = "";

/* === Direct product URLs by size (provided) === */
const PRODUCT_URLS = {
  mat: {
    "2x3": "https://www.greek-rugs.com/products/small-customizable-mat-2x3",
    "3x4": "https://www.greek-rugs.com/products/medium-customizable-mat-3x4",
    "4x6": "https://www.greek-rugs.com/products/large-customizable-mat-4x6"
  },
  rug: {
    "4x5": "https://www.greek-rugs.com/products/small-custom-rug",
    "5x8": "https://www.greek-rugs.com/products/medium-customizable-rug-5x8",
    "8x11": "https://www.greek-rugs.com/products/large-customizable-rug-8x11"
  }
};

// Organizations object (each org appears only once, sorted alphabetically)
const organizations = {
  "alpha-chi-omega": {
    name: "Alpha Chi Omega",
    logos: [
      { name: "AXO Letters Red", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/AXO_Letters_RED.png?v=1741552620" },
      { name: "AXO Letters Black", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/AXO_Letters_BLK.png?v=1741552621" },
      { name: "AXO Letters White", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/AXO_Letters_WHT.png?v=1741552621" },
      { name: "AXO Primary Logo (Vertical)", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/AXO_PrimaryLogo_Vertical.png?v=1741552621" },
      { name: "AXO Primary Logo (Horizontal)", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/AXO_PrimaryLogo_Horizontal.png?v=1741552621" },
      { name: "AXO Coat of Arms", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/AXO_CoA_Color.png?v=1741552621" }
    ],
    colors: [
      { name: "Scarlet", code: "#C81E3C" },
      { name: "Olive", code: "#7B933D" },
      { name: "Olympus", code: "#BDC3D8" },
      { name: "Vega", code: "#31758A" },
      { name: "Iris", code: "#7D6EAC" },
      { name: "Hera", code: "#F0D1D6" },
      { name: "Lyre", code: "#FBCBC3" },
      { name: "Greencastle", code: "#8B957B" },
      { name: "Ebony", code: "#3D3C3A" },
      { name: "Chord", code: "#B6B7BA" }
    ],
    customMessage: "Create Your Own Design & Save 10%!"
  },
  "alpha-delta-pi": {
    name: "Alpha Delta Pi",
    logos: [
      { name: "ADP Letters White", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/ADP_Letters_WHT.png?v=1741556234" },
      { name: "ADP Letters Azure", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/ADP_Letters_Azure.png?v=1741556234" },
      { name: "ADP Letters Black", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/ADP_Letters_BLK.png?v=1741556234" },
      { name: "ADP Primary Logo", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/ADP_Primarylogo.png?v=1741556234" },
      { name: "ADP Crest Color", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/ADP_Crest_Color.png?v=1741556234" }
    ],
    colors: [
      { name: "Azure", code: "#0071CE" },
      { name: "Midnight", code: "#002D5C" },
      { name: "Adelphan Blue", code: "#7582BD" },
      { name: "Diamond", code: "#FFFFFF" },
      { name: "Horizon", code: "#DAE1E9" },
      { name: "Sand", code: "#CBC3BB" },
      { name: "Woodland Violet", code: "#C8B0C5" }
    ],
    customMessage: "Create Your Own Design & Save 10%!"
  },
  "alpha-omicron-pi": {
    name: "Alpha Omicron Pi",
    logos: [
      { name: "AOP Tagline Color", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/AOP_Logo_Tagline_Color.png?v=1741632939" },
      { name: "AOP Letters Red", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/AOP_Letters_RED.png?v=1741632939" },
      { name: "AOP Letters Black", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/AOP_Letters_BLK.png?v=1741632939" },
      { name: "AOP Letters White", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/AOP_Letters_WHT.png?v=1741632939" },
      { name: "AOP Infinity Rose", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/AOP_Infinity_Rose_Color.png?v=1741632939" }
    ],
    colors: [
      { name: "Ambitious Pink", code: "#EF436D" },
      { name: "Cardinal Red", code: "#C22032" },
      { name: "Confident Coral", code: "#E26E5C" },
      { name: "Promising Purple", code: "#724B55" },
      { name: "Arthritis Blue", code: "#0072A1" },
      { name: "Humble Gray", code: "#D8D9D6" },
      { name: "Barnard Blue", code: "#87B3D1" },
      { name: "Graduate Gray", code: "#565F5F" }
    ],
    customMessage: "Create Your Own Design & Save 10%!"
  },
  "alpha-phi": {
    name: "Alpha Phi",
    logos: [
      { name: "AP Letters Red", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/AP_Letters_RED.png?v=1741694298" },
      { name: "AP Traditional Wordmark", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/AP_Traditional_Wordmark.png?v=1741694298" },
      { name: "AP Crest Color", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/AP_Crest_Color.png?v=1741694298" },
      { name: "AP Letters White", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/AP_Letters_WHT.png?v=1741694298" },
      { name: "AP Letters Black", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/AP_Letters_BLK.png?v=1741694298" }
    ],
    colors: [
      { name: "Bordeaux", code: "#7C1B31" },
      { name: "Berry", code: "#9B234B" },
      { name: "Rose", code: "#E7C2CC" },
      { name: "Blush", code: "#F4D3DA" },
      { name: "Steel Blue", code: "#5B7E8B" },
      { name: "Iceberg", code: "#A3BFC6" },
      { name: "Powder Blue", code: "#B9D0DB" },
      { name: "Fern", code: "#9B9F85" },
      { name: "Ivy", code: "#5D5E54" },
      { name: "Sand", code: "#D9C7B8" },
      { name: "Ivory", code: "#F2EFE9" },
      { name: "Silver", code: "#C3C2C0" }
    ],
    customMessage: "Create Your Own Design & Save 10%!"
  },
  "alpha-tau-omega": {
    name: "Alpha Tau Omega",
    logos: [
      { name: "ATO Crest Color", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/ATO_Crest_Color.png?v=1742401368" },
      { name: "ATO Letter Logo", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/ATO_Letter_Logo.png?v=1742401368" },
      { name: "ATO Letters GOLD", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/ATO_Letters_GOLD.png?v=1742401368" },
      { name: "ATO Letters BLU", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/ATO_Letters_BLU.png?v=1742401368" },
      { name: "ATO Letters BLK", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/ATO_Letters_BLK.png?v=1742401368" }
    ],
    colors: [
      { name: "Azure", code: "#487FC0" },
      { name: "Old Gold", code: "#F2A533" },
      { name: "Dark Blue", code: "#2B4E9C" },
      { name: "Dark Gold", code: "#CF8F00" },
      { name: "Sky Blue", code: "#5091CD" },
      { name: "Yellow", code: "#FFED6C" },
      { name: "Evergreen", code: "#34543D" },
      { name: "White", code: "#FFFFFF" },
      { name: "Soft Gray", code: "#D2D4D9" },
      { name: "Night", code: "#2D2C2C" },
      { name: "Black", code: "#000000" }
    ],
    customMessage: "Create Your Own Design & Save 10%!"
  },
  "beta-theta-pi": {
    name: "Beta Theta Pi",
    logos: [
      { name: "BTP Crest Colors", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/BTP_Crest_Colors.png?v=1742404137" },
      { name: "BTP Horizontal Logo", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/BTP_HorizontalLogo.png?v=1742404137" },
      { name: "BTP Letters Navy", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/BTP_Letters_NVY.png?v=1742404137" }
    ],
    colors: [
      { name: "Pantone 294", code: "#002E6C" },
      { name: "Pantone 2945", code: "#004C97" },
      { name: "Pantone Process Blue", code: "#0085ca" },
      { name: "Pantone Cool Gray 1", code: "#d9d9d6" },
      { name: "Pantone 7621", code: "#ab2328" },
      { name: "Black", code: "#000000" },
      { name: "White", code: "#ffffff" }
    ],
    customMessage: "Create Your Own Design & Save 10%!"
  },
  "chi-phi": {
    name: "Chi Phi",
    logos: [
      { name: "CP Coat of Arms", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/CP_CoA.png?v=1757012812" },
      { name: "CP Chakett", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/CP_Chakett.png?v=1757012811" },
      { name: "CP Chakett 2", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/CP_Chakett_2.png?v=1757012811" },
      { name: "CP Chakett BW", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/CP_Chakett_BW.png?v=1757012812" },
      { name: "CP Letters White", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/CO_Letters_WHT.png?v=1741728581" },
      { name: "Cp Letters Red", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/CP_Letters_RED.png?v=1757012811" },
      { name: "Cp Letters Blue", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/CP_Letters_BLU.png?v=1757012811" },
      { name: "Cp Letters Yellow", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/CP_Letters_YLW.png?v=1757012811" }
    ],
    colors: [
      { name: "Gold", code: "#E2A856" },
      { name: "Scarlet", code: "#E8112D" },
      { name: "Blue", code: "#0038A8" },
      { name: "Black", code: "#000000" },
      { name: "White", code: "#ffffff" }
    ],
    customMessage: "Create Your Own Design & Save 10%!"
  },
  "chi-omega": {
    name: "Chi Omega",
    logos: [
      { name: "CO Coat of Arms (Color)", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/CO_CoA_Color.png?v=1741728581" },
      { name: "CO Official Logo (Color)", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/CO_Official_Logo_Color.png?v=1741728581" },
      { name: "CO Letters Red", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/CO_Letters_RED.png?v=1741728581" },
      { name: "CO Letters Yellow", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/CO_Letters_YLW.png?v=1741728581" },
      { name: "CO Letters White", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/CO_Letters_WHT.png?v=1741728581" }
    ],
    colors: [
      { name: "Straw", code: "#EED484" },
      { name: "Cardinal", code: "#C8102E" }
    ],
    customMessage: "Create Your Own Design & Save 10%!"
  },
  "delta-chi": {
    name: "Delta Chi",
    logos: [
      { name: "DC Coat of Arms (Color)", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/DC_CoA_Color.png?v=1742409573" },
      { name: "DC Vertical Logo", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/DC_VerticalLogo.png?v=1742409573" },
      { name: "DC Horizontal Logo", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/DC_HorizontalLogo.png?v=1742409573" },
      { name: "DC Badge", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/DC_Badge.png?v=1742409573" }
    ],
    colors: [
      { name: "Red", code: "#ca3d31" },
      { name: "Yellow", code: "#f1bd19" },
      { name: "Navy Blue", code: "#111375" },
      { name: "Bluish Gray", code: "#9fa4a7" },
      { name: "Beige", code: "#e7dbb4" },
      { name: "Orange", code: "#d17229" },
      { name: "Blue Green", code: "#00a98e" },
      { name: "Black", code: "#000000" },
      { name: "White", code: "#ffffff" }
    ],
    customMessage: "Create Your Own Design & Save 10%!"
  },
  "delta-delta-delta": {
    name: "Delta Delta Delta",
    logos: [
      { name: "DDD Vertical Logo (White)", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/CMYK_Tricon_Vertical_White_800x800_bb5c2677-9ef3-4390-8128-3959574eb566.png?v=1743086416" },
      { name: "DDD Horizontal Logo (White)", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/CMYK_Tricon_Horizontal_White_2400x1200_5c35d4b4-093d-4874-9415-b4c917ebdd98.png?v=1743086416" }
    ],
    colors: [
      { name: "Cerulean Blue", code: "#0047BB" },
      { name: "Gold", code: "#F1C400" },
      { name: "Silver", code: "#9B9B9B" },
      { name: "Bright Blue", code: "#0C5DDE" },
      { name: "Black", code: "#000000" },
      { name: "White", code: "#ffffff" }
    ],
    borders: [
      { name: "Default Border", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/DDD_Customizer_Border.svg?v=1743094036" }
    ],
    customMessage: "Create Your Own Design & Save 10%!"
  },
  "delta-gamma": {
    name: "Delta Gamma",
    logos: [
      { name: "DG Brandmark Black", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/DG_Brandmark_BLK.png?v=1741726787" },
      { name: "DG Brandmark Navy", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/DG_Brandmark_NVY.png?v=1741726787" },
      { name: "DG Brandmark Pink", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/DG_Brandmark_PNK.png?v=1741726787" },
      { name: "DG Brandmark Gold", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/DG_Brandmark_GLD.png?v=1741726787" },
      { name: "DG Primary Logo", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/DG_Primary_Logo.png?v=1741726787" },
      { name: "DG Crest Color", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/DG_Crest_Color.png?v=1741726787" }
    ],
    colors: [
      { name: "DG Navy", code: "#003356" },
      { name: "DG Pink", code: "#F8BBC3" },
      { name: "Cable Bronze", code: "#BB8F52" },
      { name: "Paper White", code: "#FFFFFF" }
    ],
    customMessage: "Create Your Own Design & Save 10%!"
  },
  "Freemasonry": {
    name: "Freemasonry",
    productHandles: { mat: "freemason-custom-mat", rug: "freemason-custom-rug" },
    logos: [
      { name: "S&C 1 YLW", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/S_C_1_YLW.png?v=1755725277" },
      { name: "S&C 1 BLU", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/S_C_1_BLU.png?v=1755725277" },
      { name: "S&C 1 BLK", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/S_C_1_BLK.png?v=1755725277" },
      { name: "S&C 1 WHT", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/S_C_1_WHT.png?v=1755725277" },
      { name: "S&C 2 YLW", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/S_C_2_YLW.png?v=1755725277" },
      { name: "S&C 2 BLU", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/S_C_2_BLU.png?v=1755725277" },
      { name: "S&C 2 BLK", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/S_C_2_BLK.png?v=1755725277" },
      { name: "S&C 2 WHT", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/S_C_2_WHT.png?v=1755725277" }
    ],
    colors: [
      { name: "Masonic Blue", code: "#2e409a" },
      { name: "Masonic Gold", code: "#ffd628" },
      { name: "Black", code: "#000000" },
      { name: "White", code: "#FFFFFF" }
    ],
    borders: [
      { name: "Border 1", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/MasonBorder1.svg?v=1755722592" }
    ],
    customMessage: "Create Your Own Design & Save 10%!"
  },

  "gamma-phi-beta": {
    name: "Gamma Phi Beta",
    logos: [
      { name: "GPB Coat of Arms (Color)", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/GPB_CoA_Color.png?v=1741729853" },
      { name: "GPB Primary Logo (Color)", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/GPB_Primary_Logo_Color.png?v=1741729848" },
      { name: "GPB Primary Symbol (Color)", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/GPB_Primary_Symbol_Color.png?v=1741729848" },
      { name: "GPB Letters Pink", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/GPB_Letters_PNK.png?v=1741729843" },
      { name: "GPB Letters Gray", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/GPB_Letters_GRY.png?v=1741729853" },
      { name: "GPB Letters Black", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/GPB_Letters_BLK.png?v=1741729853" }
    ],
    colors: [
      { name: "Blush", code: "#F8B1AA" },
      { name: "A-La-Mode", code: "#A69895" },
      { name: "Once in a Blue Moon", code: "#7B9BA8" },
      { name: "Pearl", code: "#F1E8E3" },
      { name: "Brownstone", code: "#6B6058" },
      { name: "Carnation", code: "#E46274" }
    ],
    customMessage: "Create Your Own Design & Save 10%!"
  },
  "kappa-alpha": {
    name: "Kappa Alpha",
    logos: [
      { name: "KA Coat of Arms", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/KA_Logo_CoA.png?v=1741005812" },
      { name: "KA Letters Black", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/KA_LettersBlk.png?v=1741005812" },
      { name: "KA Letters Red", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/KA_LettersRED.png?v=1741005812" },
      { name: "KA Letters Yellow", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/KA_LettersYLW.png?v=1741005812" },
      { name: "KA Letters White", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/KA_LettersWHT.png?v=1741005812" }
    ],
    colors: [
      { name: "Blood / Crimson", code: "#9d2235" },
      { name: "Treasure / Old Gold", code: "#eaaa00" },
      { name: "White", code: "#ffffff" },
      { name: "Black", code: "#000000" }
    ],
    customMessage: "Create Your Own Design & Save 10%!"
  },
  "kappa-alpha-theta": {
    name: "Kappa Alpha Theta",
    logos: [
      { name: "KAT Vertical Logo (Color)", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/KAT_VerticalLogo_Color.png?v=1741732087" },
      { name: "KAT Horizontal Logo (Color)", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/KAT_HorizontalLogo_Color.png?v=1741732082" },
      { name: "KAT Coat of Arms (Color)", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/KAT_CoA_Color.png?v=1741731975" },
      { name: "KAT Letters Gold", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/KAT_Letters_GLD.png?v=1741731975" },
      { name: "KAT Letters Black", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/KAT_Letters_BLK.png?v=1741731975" },
      { name: "KAT Letters White", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/KAT_Letters_WHT.png?v=1741731975" }
    ],
    colors: [
      { name: "Theta Gold", code: "#DEC66A" },
      { name: "Theta Black", code: "#010101" },
      { name: "Tlam Pink", code: "#FBBFA6" },
      { name: "Asbury Blue", code: "#B8C9E1" },
      { name: "Pansy Leaf Green", code: "#4C7061" },
      { name: "Flying Kite Purple", code: "#3E3E6C" }
    ],
    customMessage: "Create Your Own Design & Save 10%!"
  },
  "kappa-delta": {
    name: "Kappa Delta",
    logos: [
      { name: "KD Greek Logo (Color)", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/KD_Greek_Logo_Color.png?v=1741734974" },
      { name: "KD Primary Logo (Color)", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/KD_PrimaryLogo_Color.png?v=1741734974" },
      { name: "KD Crest (Color)", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/KD_Crest_Color.png?v=1741734974" }
    ],
    colors: [
      { name: "Kappa Delta Olive", code: "#8D9000" },
      { name: "Soft Gray", code: "#F0F1F3" },
      { name: "Pearl White", code: "#FBFEFF" },
      { name: "Dark Olive", code: "#476749" },
      { name: "Light Olive", code: "#F1F4E3" },
      { name: "Basil Burgundy", code: "#6F1834" },
      { name: "Active Pink", code: "#E83D64" },
      { name: "Blush Pink", code: "#FDE6E6" },
      { name: "Confident Coral", code: "#F89679" },
      { name: "Clover Clay", code: "#F6B39B" },
      { name: "Confident Peach", code: "#F5B29E" }
    ],
    customMessage: "Create Your Own Design & Save 10%!"
  },
  "kappa-delta-rho": {
    name: "Kappa Delta Rho",
    logos: [
      { name: "KDR Coat of Arms (Color)", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/KDR_CoA_Color.png?v=1742424176" },
      { name: "KDR Letters Navy", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/KDR_Letters_NAVY.png?v=1742424175" },
      { name: "KDR Letters Orange", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/KDR_Letters_ORNG.png?v=1742424175" },
      { name: "KDR Letters Black", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/KDR_Letters_BLCK.png?v=1742424175" }
    ],
    colors: [
      { name: "Middlebury Blue", code: "#002E6D" },
      { name: "Princeton Orange", code: "#EE7623" },
      { name: "Black", code: "#000000" },
      { name: "White", code: "#FFFFFF" }
    ],
    customMessage: "Create Your Own Design & Save 10%!"
  },
  "kappa-kappa-gamma": {
    name: "Kappa Kappa Gamma",
    logos: [
      { name: "KKG Letters Fleur Color", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/KKG_Letters_Fleur_Color.png?v=1741735548" },
      { name: "KKG Letters Yellow", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/KKG_Letters_YLW.png?v=1741735548" },
      { name: "KKG Letters Blue", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/KKG_Letters_BLU.png?v=1741735581" },
      { name: "KKG Letters Black", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/KKG_Letters_BLK.png?v=1741735548" },
      { name: "KKG Coat of Arms Color", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/KKG_CoA_Color.png?v=1741735548" }
    ],
    colors: [
      { name: "Kappa Blue", code: "#0060CE" },
      { name: "Gamma Blue", code: "#002D62" },
      { name: "Bright Blue", code: "#0C3F95" },
      { name: "Key Gold", code: "#D2B715" },
      { name: "Light Blue", code: "#C9E2EB" },
      { name: "Silver", code: "#A0A4AD" },
      { name: "Dark Silver", code: "#686D70" }
    ],
    customMessage: "Create Your Own Design & Save 10%!"
  },
  "kappa-sigma": {
    name: "Kappa Sigma",
    logos: [
      { name: "KS Coat of Arms (Color)", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/KS_Crest_Color.png?v=1742424944" },
      { name: "KS Logo Tagline", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/KS_Logo_Tagline.png?v=1742424944" },
      { name: "KS Letters Green", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/KS_Letters_GRN.png?v=1742424944" },
      { name: "KS Letters Red", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/KS_Letters_RED.png?v=1742424944" },
      { name: "KS Letters Black", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/KS_Letters_BLCK.png?v=1742424944" }
    ],
    colors: [
      { name: "Red", code: "#BF0D3E" },
      { name: "Green", code: "#215732" },
      { name: "Gold", code: "#C99700" },
      { name: "Black", code: "#000000" },
      { name: "White", code: "#FFFFFF" }
    ],
    customMessage: "Create Your Own Design & Save 10%!"
  },
  "lambda-chi-alpha": {
    name: "Lambda Chi Alpha",
    productHandles: { mat: "lambda-chi-alpha-custom-mat", rug: "lambda-chi-alpha-custom-rug" },
    logos: [
      { name: "LCA Logo Stacked", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/LCA_Logo_Stacked.png?v=1757009141" },
      { name: "LCA Coat Of Arms", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/LCA_COA_NoBck.png?v=1757009012" },
      { name: "LCA Icon White", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/LCA_Icon_WHT.png?v=1757009012" },
      { name: "LCA Icon Black", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/LCA_Icon_BLK.png?v=1757009012" },
      { name: "LCA Icon Purple", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/LCA_Logo_PRPL.png?v=1757009012" },
      { name: "LCA Icon Yellow", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/LCA_Icon_YLW.png?v=1757009012" },
      { name: "LCA Icon Green", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/LCA_Icon_GRN.png?v=1757009012" },
      { name: "LCA Letters Green", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/LCA_Letters_GRN.png?v=1757009012" },
      { name: "LCA Letters Purple", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/LCA_Letters_PRPL.png?v=1757009012" },
      { name: "LCA Letters Yellow", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/LCA_Letters_YLW.png?v=1757009012" }
    ],
    colors: [
      { name: "Yellow", code: "#fab51b" },
      { name: "Green", code: "#00453d" },
      { name: "Purple", code: "#50307c" },
      { name: "Black", code: "#000000" },
      { name: "White", code: "#FFFFFF" }
    ],
    customMessage: "Create Your Own Design & Save 10%!"
  },
  "phi-delta-theta": {
    name: "Phi Delta Theta",
    logos: [
      { name: "Phi Delta Theta Logo", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/Phi_Delta_Theta_Logo.png?v=1741960718" }
    ],
    colors: [
      { name: "Navy", code: "#0D1433" },
      { name: "Blue", code: "#619DC7" },
      { name: "Light Blue", code: "#DDECF3" },
      { name: "Blue Gray", code: "#5B7E8B" },
      { name: "Gold", code: "#F2B100" },
      { name: "Gray", code: "#939597" },
      { name: "Red", code: "#C8102E" }
    ],
    customMessage: "Create Your Own Design & Save 10%!"
  },
  "phi-gamma-delta": {
    name: "Phi Gamma Delta",
    logos: [
      { name: "PGD Crest (Color)", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/PGD_Crest_Color.png?v=1742426031" },
      { name: "PGD Logo Tagline", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/PGD_Logo_Tagline.png?v=1742426031" },
      { name: "PGD Diamond (Color)", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/PGD_Diamond_Color.png?v=1742426031" },
      { name: "PGD FIJI (Black)", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/PGD_FIJI_BLCK.png?v=1742426031" },
      { name: "PGD FIJI (Purple)", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/PGD_FIJI_PRPL.png?v=1742426031" },
      { name: "PGD FIJI (Gold)", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/PGD_FIJI_GOLD.png?v=1742426030" }
    ],
    colors: [
      { name: "Purple", code: "#520975" },
      { name: "Yellow", code: "#cba900" },
      { name: "Gray", code: "#8e8e91" },
      { name: "Gold", code: "#9f8a48" },
      { name: "Red", code: "#f0492f" },
      { name: "Black", code: "#000000" },
      { name: "White", code: "#FFFFFF" }
    ],
    customMessage: "Create Your Own Design & Save 10%!"
  },
  "phi-kappa-theta": {
    name: "Phi Kappa Theta",
    logos: [
      { name: "PKT Crest (Color)", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/PKT_Crest_Color.png?v=1742497364" },
      { name: "PKT Vertical (RGB)", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/Phi-Kappa-Theta-PKT_Vertical_RGB.png?v=1742497129" },
      { name: "PKT Horizontal (RGB)", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/Phi-Kappa-Theta-PKT_Horizontal_RGB.png?v=1742497129" },
      { name: "PKT Logo Mark (RGB)", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/Phi-Kappa-Theta-Phi_Kappa_Theta_Logo_Mark_RGB.png?v=1742497129" }
    ],
    colors: [
      { name: "Cardinal Purple Red", code: "#75140C" },
      { name: "Gold (Dark)", code: "#D6AD60" },
      { name: "White (Light)", code: "#F4F1EA" },
      { name: "Black", code: "#231F20" },
      { name: "Cardinal Purple", code: "#800000" },
      { name: "Gold (Bright)", code: "#FBD410" },
      { name: "White", code: "#FFFFFF" }
    ],
    customMessage: "Create Your Own Design & Save 10%!"
  },
  "phi-mu": {
    name: "Phi Mu",
    logos: [
      { name: "Phi Mu Primary Logo (Horizontal)", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/Phi_Mu_PrimaryLogo_Horizontal.png?v=1743256687" },
      { name: "Phi Mu Letters (Pink)", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/Phi_Mu_Letters_PINK.png?v=1743256687" },
      { name: "Phi Mu Letters (Grey)", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/Phi_Mu_Letters_GREY.png?v=1743256772" }
    ],
    colors: [
      { name: "Carnation", code: "#F681A2" },
      { name: "Magnolia", code: "#F2B9D9" },
      { name: "Blush", code: "#F8B1BD" },
      { name: "Petal", code: "#F2CAD8" },
      { name: "Charcoal", code: "#4F4F4F" },
      { name: "Pewter", code: "#999999" },
      { name: "Granite", code: "#686868" },
      { name: "Marble", code: "#CCCCCC" },
      { name: "Wesleyan Purple", code: "#663399" },
      { name: "Citrus", code: "#FFD700" },
      { name: "Sunflower", code: "#FFD54F" },
      { name: "Midnight", code: "#003366" }
    ],
    customMessage: "Create Your Own Design & Save 10%!"
  },
  "pi-beta-phi": {
    name: "Pi Beta Phi",
    logos: [
      { name: "PBP Crest Color", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/PBP_Crest_Color.png?v=1741735975" },
      { name: "PBP Primary Logo (White)", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/PBP_PrimaryLogo_WHT.png?v=1741735975" },
      { name: "PBP Primary Logo (Red)", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/PBP_PrimaryLogo_RED.png?v=1741735975" },
      { name: "PBP Primary Logo (Color)", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/PBP_PrimaryLogo_Color.png?v=1741735975" },
      { name: "PBP Primary Logo (Black)", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/PBP_PrimaryLogo_BLK.png?v=1741735974" },
      { name: "PBP Primary Logo (Blue)", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/PBP_PrimaryLogo_BLU.png?v=1741735975" },
      { name: "PBP Letters White", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/PBP_Letters_WHT.png?v=1741735974" },
      { name: "PBP Letters Red", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/PBP_Letters_RED.png?v=1741735974" },
      { name: "PBP Letters Black", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/PBP_Letters_BLK.png?v=1741735974" },
      { name: "PBP Letters Blue", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/PBP_Letters_BLU.png?v=1741735974" }
    ],
    colors: [
      { name: "Silver Blue", code: "#DDE5ED" },
      { name: "Wine", code: "#8B1A6C" },
      { name: "Heritage Wine", code: "#904736" },
      { name: "Rose", code: "#E78A8E" },
      { name: "Heritage Gray", code: "#9B9B9B" },
      { name: "Dark Gray", code: "#686D70" }
    ],
    customMessage: "Create Your Own Design & Save 10%!"
  },
  "pi-kappa-alpha": {
    name: "Pi Kappa Alpha",
    logos: [
      { name: "PKA Letters Gold", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/PKA_LettersGold.png?v=1741202065" },
      { name: "PKA Pike Gold", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/PKA_PikeGOLD.png?v=1741202065" },
      { name: "PKA Pike Red", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/PKA_PikeRED.png?v=1741202065" },
      { name: "PKA Letters Black", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/PKA_LettersBLK.png?v=1741202065" },
      { name: "PKA Pike Black", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/PKA_PikeBLK.png?v=1741202065" },
      { name: "PKA Letters Red", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/PKA_LettersRED.png?v=1741202065" },
      { name: "PKA Coat of Arms", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/PKA_CoA.png?v=1741201745" }
    ],
    colors: [
      { name: "Black", code: "#000000" },
      { name: "White", code: "#ffffff" },
      { name: "Garnet", code: "#79242F" },
      { name: "Gold", code: "#9E8959" },
      { name: "Brotherhood Burgundy", code: "#91324F" },
      { name: "Courageous Crimson", code: "#8B1B2E" },
      { name: "Memphis Brick", code: "#992F38" },
      { name: "Oak", code: "#4C4020" },
      { name: "Old Gold", code: "#A1884E" },
      { name: "True Gold", code: "#A47E2E" },
      { name: "Khaki Gold", code: "#CAB883" },
      { name: "Light Gold", code: "#E3D4B2" },
      { name: "Tillar Taupe", code: "#C7B299" },
      { name: "Slate", code: "#46494B" },
      { name: "Dagger Gray", code: "#4F5359" },
      { name: "King Steel", code: "#939597" },
      { name: "Shield Silver", code: "#B8B9BA" },
      { name: "Light Silver", code: "#D3D4D5" }
    ],
    customMessage: "Create Your Own Design & Save 10%!"
  },
  "sigma-alpha-epsilon": {
    name: "Sigma Alpha Epsilon",
    logos: [
      { name: "SAE Crest (Color)", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/SAE_Crest_Color.png?v=1742506845" },
      { name: "SAE Shield (Color)", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/SAE_Shield_Color.png?v=1742506846" },
      { name: "SAE Primary Logo (Purple/Gold)", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/Sigma-Alpha-Epsilon-SAE_Primary_Logo_Purple_Gold_Transparent.png?v=1742506731" },
      { name: "SAE Greek Logo (Purple)", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/Sigma-Alpha-Epsilon-SAE_Greek_Logo_Purple_Transparent.png?v=1742506731" },
      { name: "SAE Greek Logo (Purple/Gold)", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/Sigma-Alpha-Epsilon-SAE_Greek_Logo_Purple_Gold_Transparent.png?v=1742506730" },
      { name: "SAE Greek Logo (Gold)", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/Sigma-Alpha-Epsilon-SAE_Greek_Logo_Gold_Transparent.png?v=1742506731" },
      { name: "SAE Simplified Shield (Gold)", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/Sigma-Alpha-Epsilon-Simplified_Shield_Gold.png?v=1742506725" },
      { name: "SAE Simplified Shield (Purple)", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/Sigma-Alpha-Epsilon-Simplified_Shield_Purple.png?v=1742506725" },
      { name: "SAE Shield (Purple/Gold Transparent)", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/Sigma-Alpha-Epsilon-Shield_Purple_and_Gold_Transparent.png?v=1742506646" },
      { name: "SAE Greek Logo (Gold v2)", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/Sigma-Alpha-Epsilon-SAE_Greek_Logo_Gold_Transparent.png?v=1742506642" },
      { name: "SAE Shield (Gold Transparent)", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/Sigma-Alpha-Epsilon-Shield_Gold_Transparent.png?v=1742506642" }
    ],
    colors: [
      { name: "SAE Gold (Primary)", code: "#F4BD1D" },
      { name: "SAE Purple (Primary)", code: "#6A498E" },
      { name: "SAE Black", code: "#000000" },
      { name: "SAE Gold (Secondary)", code: "#B37D38" }
    ],
    customMessage: "Create Your Own Design & Save 10%!"
  },
  "sigma-chi": {
    name: "Sigma Chi",
    logos: [
      { name: "SC Coat of Arms (Color)", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/SC_CoA_Color.png?v=1742581655" },
      { name: "SC Shield Color", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/SC_Shield_Color.png?v=1742581654" },
      { name: "SC Letters Black", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/SC_Letters_BLK.png?v=1742582029" },
      { name: "SC Letters White", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/SC_Letters_WHT.png?v=1742582029" },
      { name: "SC Letters Yellow", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/SC_Letters_YLW.png?v=1742582029" },
      { name: "SC Letters Navy", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/SC_Letters_NVY.png?v=1742582029" }
    ],
    colors: [
      { name: "Pantone 299 C", code: "#00a3e0" },
      { name: "Pantone 122 C", code: "#f1d10f" },
      { name: "Pantone 7463 C", code: "#002b49" },
      { name: "Pantone 7546 C", code: "#1f1e1d" },
      { name: "Black", code: "#000000" },
      { name: "CEO Yellow", code: "#fcf000" },
      { name: "Pantone 874 C", code: "#85641e" },
      { name: "Pantone 2995 C", code: "#71c2db" }
    ],
    customMessage: "Create Your Own Design & Save 10%!"
  },
  "sigma-kappa": {
    name: "Sigma Kappa",
    logos: [
      { name: "SK Crest Color", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/SK_Crest_Color.png?v=1742329741" },
      { name: "SK Logo Tagline", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/SK_Logo_Tagline.png?v=1742329741" },
      { name: "SK Horizontal Logo", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/SK_HorizontalLogo.png?v=1742329741" }
    ],
    colors: [
      { name: "Purple", code: "#441155" },
      { name: "Lavender", code: "#DECCE3" },
      { name: "Maroon", code: "#881133" },
      { name: "Black", code: "#000000" },
      { name: "White", code: "#ffffff" }
    ],
    customMessage: "Create Your Own Design & Save 10%!"
  },
    "sigma-nu": {
    name: "Sigma Nu",
    logos: [
      { name: "SN Coat of Arms (Color)", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/SN_CoA_Color.png?v=1742584802" },
      { name: "SN Badge (Color)", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/SN_Badge_Color.png?v=1742584802" },
      { name: "SN Letters (873C)", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/EN.png?v=1753380839" }
    ],
    colors: [
      { name: "PMS 108 U", code: "#FFC600" },
      { name: "PMS Black U2", code: "#231F20" },
      { name: "Black", code: "#000000" },
      { name: "White", code: "#ffffff" },
      { name: "PMS 873 C", code: "#846E48" },
      { name: "PMS 404 U", code: "#615D59" },
      { name: "PMS 485 U", code: "#E45A4F" }
    ],
    customMessage: "Create Your Own Design & Save 10%!"
  },

  "sigma-pi": {
    name: "Sigma Pi",
    logos: [
      { name: "SP Crest Color", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/SK_Crest_Color.png?v=1742329741" },
      { name: "SP Logo Tagline", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/SK_Logo_Tagline.png?v=1742329741" },
      { name: "SP Horizontal Logo", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/SK_HorizontalLogo.png?v=1742329741" }
    ],
    colors: [
      { name: "Sigma Pi Gold", code: "#d0b787" },
      { name: "Sigma Pi Purple", code: "#403a60" },
      { name: "Sigma Pi Silver", code: "#d9d8d6" },
      { name: "Black", code: "#000000" },
      { name: "White", code: "#ffffff" }
    ],
    customMessage: "Create Your Own Design & Save 10%!"
  },
  "zeta-psi": {
    name: "Zeta Psi",
    productHandles: { mat: "zeta-psi-custom-mat", rug: "zeta-psi-custom-rug" },
    logos: [
      { name: "Zeta Psi Escutcheon Full Color", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/Zeta-Psi-Zeta_Psi_Escutcheon_Full_Color_7d701af0-4af0-4bb3-9c79-8ff858474c19.png?v=1742755393" },
      { name: "ZP Letters 2-Color", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/ZP_Letters_2Color.png?v=1742755392" },
      { name: "ZP Letters Gold", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/ZP_Letters_YLW.png?v=1742755392" },
      { name: "ZP Letters White", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/ZP_Letters_WHT.png?v=1742755392" },
      { name: "ZP Letters Black", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/ZP_Letters_BLCK.png?v=1742755392" },
      { name: "ZP Horizontal Logo", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/ZP_HorizontalLogo.png?v=1742755392" }
    ],
    colors: [
      { name: "Zeta Psi Gold", code: "#FFB300" },
      { name: "Pure White", code: "#FFFFFF" },
      { name: "Pure Black", code: "#000000" }
    ],
    chapters: [
      { name: "Alpha Epsilon",   value: "Alpha Epsilon" },
      { name: "Alpha Mu",        value: "Alpha Mu" },
      { name: "Alpha Nu",        value: "Alpha Nu" },
      { name: "Alpha Pi",        value: "Alpha Pi" },
      { name: "Alpha Psi",       value: "Alpha Psi" },
      { name: "Alpha Sigma",     value: "Alpha Sigma" },
      { name: "Alpha Theta",     value: "Alpha Theta" },
      { name: "Beta",            value: "Beta" },
      { name: "Beta Delta",      value: "Beta Delta" },
      { name: "Beta Tau",        value: "Beta Tau" },
      { name: "Chi Gamma",       value: "Chi Gamma" },
      { name: "Chi Tau",         value: "Chi Tau" },
      { name: "Delta",           value: "Delta" },
      { name: "Delta Alpha",     value: "Delta Alpha" },
      { name: "Delta Chi",       value: "Delta Chi" },
      { name: "Delta Pi",        value: "Delta Pi" },
      { name: "Eta",             value: "Eta" },
      { name: "Gamma Epsilon",   value: "Gamma Epsilon" },
      { name: "Gamma Psi",       value: "Gamma Psi" },
      { name: "Iota",            value: "Iota" },
      { name: "Iota Alpha",      value: "Iota Alpha" },
      { name: "Iota Delta",      value: "Iota Delta" },
      { name: "Iota Nu",         value: "Iota Nu" },
      { name: "Iota Omicron",    value: "Iota Omicron" },
      { name: "Iota Pi",         value: "Iota Pi" },
      { name: "Kappa Alpha",     value: "Kappa Alpha" },
      { name: "Kappa Beta",      value: "Kappa Beta" },
      { name: "Kappa Delta",     value: "Kappa Delta" },
      { name: "Kappa Phi",       value: "Kappa Phi" },
      { name: "Mu Pi",           value: "Mu Pi" },
      { name: "Mu Theta",        value: "Mu Theta" },
      { name: "Nu",              value: "Nu" },
      { name: "Nu Delta",        value: "Nu Delta" },
      { name: "Omega Alpha",     value: "Omega Alpha" },
      { name: "Omicron",         value: "Omicron" },
      { name: "Omicron Epsilon", value: "Omicron Epsilon" },
      { name: "Phi",             value: "Phi" },
      { name: "Phi Epsilon",     value: "Phi Epsilon" },
      { name: "Phi Lambda",      value: "Phi Lambda" },
      { name: "Pi",              value: "Pi" },
      { name: "Pi Kappa",        value: "Pi Kappa" },
      { name: "Pi Sigma",        value: "Pi Sigma" },
      { name: "Pi Tau",          value: "Pi Tau" },
      { name: "Psi",             value: "Psi" },
      { name: "Psi Epsilon",     value: "Psi Epsilon" },
      { name: "Psi Omicron",     value: "Psi Omicron" },
      { name: "Rho Alpha",       value: "Rho Alpha" },
      { name: "Rho Tau",         value: "Rho Tau" },
      { name: "Sigma",           value: "Sigma" },
      { name: "Sigma Beta",      value: "Sigma Beta" },
      { name: "Tau",             value: "Tau" },
      { name: "Tau Gamma",       value: "Tau Gamma" },
      { name: "Tau Omicron",     value: "Tau Omicron" },
      { name: "Tau Theta",       value: "Tau Theta" },
      { name: "Theta",           value: "Theta" },
      { name: "Theta Eta",       value: "Theta Eta" },
      { name: "Theta Omicron",   value: "Theta Omicron" },
      { name: "Theta Phi",       value: "Theta Phi" },
      { name: "Theta Psi",       value: "Theta Psi" },
      { name: "Theta Xi",        value: "Theta Xi" },
      { name: "Upsilon",         value: "Upsilon" },
      { name: "Zeta Epsilon",    value: "Zeta Epsilon" },
      { name: "Zeta Tau",        value: "Zeta Tau" }
    ],
    customMessage: "Create Your Own Design & Save 10%!"
  },
  "zeta-tau-alpha": {
    name: "Zeta Tau Alpha",
    logos: [
      { name: "ZTA Crest Color", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/ZTA_Crest_Color.png?v=1742331498" },
      { name: "ZTA Primary Logo Color", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/ZTA_PrimaryLogo_Color.png?v=1742331453" },
      { name: "ZTA Letters Logo Color", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/ZTA_LettersLogo_Color.png?v=1742331453" },
      { name: "ZTA BLK Crown + Name", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/ZTA_BLK_Crown_Name.png?v=1752261472" },
      { name: "ZTA WHT Crown + Name", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/ZTA_WHT_Crown_Name.png?v=1752261657" }
    ],
    colors: [
      { name: "Turquoise", code: "#00aea0" },
      { name: "Dark Gray", code: "#919693" },
      { name: "Light Gray", code: "#adafaa" },
      { name: "Hot Pink", code: "#e22882" },
      { name: "Black", code: "#000000" },
      { name: "White", code: "#ffffff" }
    ],
    customMessage: "Create Your Own Design & Save 10%!"
  }
};

// Default borders pool (used if no organization-specific override is provided)
const defaultBorders = [
  { name: "Default Border 1", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/Customizer_Border-01.svg?v=1743023473" },
  { name: "Default Border 2", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/Customizer_Border-02.svg?v=1743218932" },
  { name: "Default Border 3", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/Customizer_Border-03.svg?v=1743023473" },
  { name: "Default Border 4", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/Customizer_Border-04.svg?v=1743023473" },
  { name: "Default Border 5", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/Customizer_Border-05.svg?v=1743023473" }
];

/* CHUNK 2: UI Structure, Event Listeners, and Preview Updates */
document.getElementById("rug-customizer-container").innerHTML = `
  <!-- Make sure your <head> includes:
       <meta name="viewport" content="width=device-width, initial-scale=1" />
  -->
  <style>
    #rug-customizer-container * { box-sizing: border-box; }
    #customizer-title{margin:10px 0;text-align:center;font-size:28px;line-height:1.2}
    @media (min-width:768px){#customizer-title{font-size:36px}}

    /* Layout */
    #customizer-wrapper{
      display:flex;flex-direction:column;gap:16px;max-width:1200px;margin:0 auto;
      justify-content:center;align-items:stretch;padding:0 4px;
    }
    @media (min-width:960px){
      #customizer-wrapper{flex-direction:row;gap:40px;align-items:flex-start}
    }

    /* Preview */
    #design-preview{
      position:relative;width:100%;max-width:600px;aspect-ratio:3/2;background:#fff;
      display:flex;align-items:center;justify-content:center;margin:10px auto;border:0 solid transparent
    }
    #top-text,#bottom-text{font-weight:700;z-index:15;pointer-events:none}
    #selectedBorderStyle{display:none;position:absolute;inset:0;z-index:5;pointer-events:none}
    #uploadedLogo{display:none;position:absolute;max-width:60%;max-height:60%;z-index:10}

    /* Controls */
    #customizer-options{
      display:grid;grid-template-columns:1fr;gap:12px;max-width:520px;padding:10px;margin:0 auto;width:100%;
    }
    @media (min-width:700px){#customizer-options{grid-template-columns:1fr 1fr}}
    #customizer-options label{display:flex;flex-direction:column;gap:6px;font-size:14px}
    #customizer-options input,#customizer-options select,#customizer-options textarea{
      padding:10px;font-size:16px;border:1px solid #d1d5db;border-radius:8px;width:100%;
      -webkit-tap-highlight-color: transparent;
    }
    #customizer-options textarea{min-height:72px}

    /* CTA */
    .cta-wrap{max-width:1200px;margin:8px auto 0;padding:0 10px;display:grid;grid-template-columns:1fr;gap:16px;justify-items:center}
    .cta-note{margin:0;font-size:13px;color:#666;line-height:1.45;text-align:center}
    .cta-right{display:flex;flex-direction:column;gap:12px;align-items:center;width:100%}
    .cta-row{display:grid;grid-template-columns:1fr 1fr;gap:12px 16px;max-width:720px;width:100%;margin:0 auto;justify-items:stretch}
    @media (max-width:539px){.cta-row{grid-template-columns:1fr}}
    .cta-col{display:flex;flex-direction:column;align-items:center;gap:6px}
    .cta-btn{display:inline-flex;align-items:center;justify-content:center;width:100%;min-height:48px;padding:10px 16px;
      font-weight:600;border-radius:8px;border:1px solid #3972ba;background:#3972ba;color:#fff;text-decoration:none}
    .cta-btn.secondary{background:#fff;color:#3972ba}
    .cta-help{font-size:12px;color:#666;text-align:center;max-width:280px;line-height:1.35}
    .btn-disabled{pointer-events:none;opacity:.5}
  </style>

  <div style="max-width:1200px;margin:0 auto;">
    <h2 id="customizer-title">Create Your Own Design & Save 10%!</h2>

    <div id="customizer-wrapper">
      <!-- Preview column -->
      <div style="flex:1;max-width:600px;margin:0 auto;text-align:center;">
        <div id="design-preview">
          <span id="top-text" style="position:absolute;top:10%;width:100%;text-align:center;"></span>
          <span id="placeholder-text" style="color:#333;font-size:16px;">Your Design Here</span>
          <div id="selectedBorderStyle"></div>
          <img id="uploadedLogo" />
          <span id="bottom-text" style="position:absolute;bottom:10%;width:100%;text-align:center;"></span>
        </div>
      </div>

      <!-- Controls column -->
      <div id="customizer-options">
        <label>Name: <input type="text" id="userNameInput" placeholder="Your Name"></label>
        <label>Email: <input type="email" id="userEmailInput" placeholder="Your Email"></label>

        <label>Product Type:
          <select id="productTypePicker">
            <option value="" selected>No Selection</option>
            <optgroup label="Entry Mats">
              <option value="2'x3' Entry Mat">2'x3' Entry Mat</option>
              <option value="3'x4' Entry Mat">3'x4' Entry Mat</option>
              <option value="4'x6' Entry Mat">4'x6' Entry Mat</option>
            </optgroup>
            <optgroup label="Rugs">
              <option value="4'x5' Rug">4'x5' Rug</option>
              <option value="5'x8' Rug">5'x8' Rug</option>
              <option value="8'x11' Rug">8'x11' Rug</option>
            </optgroup>
            <option value="Other">Other</option>
          </select>
        </label>

        <label>Base Color:
          <select id="baseColorPicker"><option value="">No Selection</option></select>
        </label>

        <label>Border Color:
          <select id="borderColorPicker"><option value="">No Selection</option></select>
        </label>

        <label>Choose Logo:
          <select id="logoPicker"><option value="">No Selection</option></select>
        </label>

        <label>Border Style:
          <select id="borderStylePicker"><option value="">No Selection</option></select>
        </label>

        <label>Top Text: <input type="text" id="topTextInput" placeholder="Optional"></label>
        <label>Bottom Text: <input type="text" id="bottomTextInput" placeholder="Optional"></label>

        <label>Text Color:
          <select id="textColorPicker"><option value="">Default (Black)</option></select>
        </label>

        <label>Orientation:
          <select id="orientationPicker">
            <option value="horizontal" selected>Horizontal</option>
            <option value="vertical">Vertical</option>
          </select>
        </label>

        <label>Additional Requests:
          <textarea id="additionalRequestsInput" placeholder="Optional"></textarea>
        </label>

        <label id="chapterContainer" style="display:none;">
          Zeta Psi Chapter:
          <select id="chapterPicker"><option value="">No Selection</option></select>
        </label>

        <p id="price-estimate" style="font-size:18px;font-weight:700;text-align:center;grid-column:1 / span 2;">
          Estimated Total: $0.00
        </p>
      </div>
    </div>

    <!-- CTAs -->
    <div id="ctaWrap" class="cta-wrap">
      <p id="customizer-footnote" class="cta-note">
        Logos may take a moment to appear. Preview text is for placement only—final type, size, and layout may be adjusted to match your request.
        Colors may vary slightly due to manufacturing. Need extra colors or a chapter logo? Want to customize another product? Other questions?
        <a href="mailto:Landon@greek-rugs.com">Email Landon@greek-rugs.com</a>.
      </p>
      <div class="cta-right">
        <div id="processHint" style="text-align:center;font-size:14px;color:#274b7a;margin:0;font-weight:600;">
          <strong>Recommended:</strong> Place your order first, then submit your design. We’ll attach your details to the order.
          <em style="display:block;font-weight:400;">Design work begins after purchase.</em>
        </div>

        <div id="ctaButtons" class="cta-row">
          <div class="cta-col" style="grid-column:1 / -1;">
            <a id="buyCustom" class="cta-btn btn-disabled" href="#" aria-disabled="true" aria-label="Buy Custom">Buy Custom</a>
            <div class="cta-help">Choose Mat or Rug + Size to continue. You’ll confirm details after checkout.</div>
          </div>
          <div class="cta-col" style="grid-column:1 / -1;">
            <button id="submitDesign" class="cta-btn secondary" type="button">Submit Design</button>
            <div class="cta-help">Not ready to buy? Share your idea—proofs begin after purchase.</div>
          </div>
        </div>
      </div>
    </div>
  </div>
`;

// Set minimal padding
document.getElementById("rug-customizer-container").style.padding = "0px 15px 0px 15px";

/* -------------------------
   Function: loadOrganizationData
------------------------- */
function loadOrganizationData() {
  console.log("loadOrganizationData() called...");
  const urlParams = new URLSearchParams(window.location.search);
  let orgParam = urlParams.get("org");
  if (!orgParam) {
    const pathParts = window.location.pathname.split("/");
    const collectionsIndex = pathParts.indexOf("collections");
    if (collectionsIndex !== -1 && pathParts.length > collectionsIndex + 1) {
      orgParam = pathParts[collectionsIndex + 1];
    }
  }
  console.log("orgParam from URL:", orgParam);

  let orgKey = "";
  if (orgParam) {
    const lowerParam = orgParam.toLowerCase();
    for (let key in organizations) {
      if (key.toLowerCase() === lowerParam) {
        orgKey = key;
        break;
      }
    }
  }
  currentOrgKey = orgKey;

  // If we found a valid org in our 'organizations' object:
  if (orgKey && organizations.hasOwnProperty(orgKey)) {
    const orgData = organizations[orgKey];
    console.log("🔹 Detected orgKey:", orgKey);
    console.log("✅ Organization Loaded:", orgData);

    // 1. Populate Base Color dropdown
    const baseColorDropdown = document.getElementById("baseColorPicker");
    if (orgKey === "delta-delta-delta") {
      baseColorDropdown.innerHTML = `<option value="#0047BB" selected>Cerulean Blue</option>`;
    } else {
      baseColorDropdown.innerHTML = `
        <option value="">No Selection</option>
        ${orgData.colors
          .map(color => `<option value="${color.code}" style="background-color:${color.code};">${color.name}</option>`)
          .join("")}
      `;
    }

    // 2. Populate Border Color dropdown
    const borderColorDropdown = document.getElementById("borderColorPicker");
    borderColorDropdown.innerHTML = `
      <option value="">No Selection</option>
      ${orgData.colors
        .map(color => `<option value="${color.code}" style="background-color:${color.code};">${color.name}</option>`)
        .join("")}
    `;
    if (orgKey === "delta-delta-delta") {
      // Tri-Delta always uses white border by default:
      borderColorDropdown.innerHTML = `
        <option value="">No Selection</option>
        <option value="#ffffff" style="background-color:#ffffff;" selected>White</option>
      `;
      borderColorDropdown.value = "#ffffff";
    }

    // 3. Populate Logo dropdown
    const logoDropdown = document.getElementById("logoPicker");
    if (logoDropdown) {
      logoDropdown.innerHTML = `
        <option value="">No Selection</option>
        ${orgData.logos.map(logo => `<option value="${logo.file}">${logo.name}</option>`).join("")}
      `;
    } else {
      console.error("❌ ERROR: Logo dropdown element not found.");
    }

    // 4. Populate Border Style dropdown (value = human label, data-svg-url = file)
    const borderStyleDropdown = document.getElementById("borderStylePicker");
    if (!borderStyleDropdown) {
      console.error("❌ ERROR: borderStylePicker element not found.");
    } else {
      if (orgKey === "delta-delta-delta") {
        borderStyleDropdown.innerHTML = `<option value="Default Border">Default Border</option>`;
      } else {
        const borders = (orgData.borders && orgData.borders.length) ? orgData.borders : defaultBorders;
        borderStyleDropdown.innerHTML = `
          <option value="">No Selection</option>
          ${borders.map(border => `
            <option value="${border.name}" data-svg-url="${border.file}">${border.name}</option>
          `).join("")}
        `;
      }
    }

    // 5. Populate Text Color dropdown
    const textColorDropdown = document.getElementById("textColorPicker");
    if (textColorDropdown) {
      textColorDropdown.innerHTML = `
        <option value="">Default (Black)</option>
        ${orgData.colors
          .map(color => `<option value="${color.code}" style="background-color:${color.code}; color:${color.code};">${color.name}</option>`)
          .join("")}
      `;
    } else {
      console.error("❌ ERROR: Text color dropdown element not found.");
    }

    // 6. Populate Chapter dropdown (only if orgData.chapters exists)
    const chapterContainer = document.getElementById("chapterContainer");
    const chapterPicker = document.getElementById("chapterPicker");
    if (Array.isArray(orgData.chapters) && orgData.chapters.length > 0) {
      chapterContainer.style.display = "block";
      chapterPicker.innerHTML = `
        <option value="">No Selection</option>
        ${orgData.chapters.map(chap => `<option value="${chap.value}">${chap.name}</option>`).join("")}
      `;
    } else {
      chapterContainer.style.display = "none";
    }

  } else {
    // If no valid org was found, blank-out every dropdown
    console.warn(`No organization data found for orgParam: '${orgParam}'. Defaulting to empty selections.`);

    document.getElementById("baseColorPicker").innerHTML = `<option value="">No Selection</option>`;
    document.getElementById("borderColorPicker").innerHTML = `<option value="">No Selection</option>`;
    document.getElementById("logoPicker").innerHTML = `<option value="">No Selection</option>`;
    document.getElementById("borderStylePicker").innerHTML = `<option value="">No Selection</option>`;
    document.getElementById("textColorPicker").innerHTML = `<option value="">Default (Black)</option>`;
    document.getElementById("chapterContainer").style.display = "none";
  }
}

/* -------------------------
   Function: updatePreview
------------------------- */
function updatePreview() {
  console.log("updatePreview() called...");
  const preview = document.getElementById("design-preview");
  if (!preview) {
    console.warn("No preview element found!");
    return;
  }

  // 1) Orientation sizing (desktop only)
  const orientationVal = document.getElementById("orientationPicker").value;
  if (window.innerWidth > 640) {
    if (orientationVal === "vertical") {
      preview.style.width = "400px";
      preview.style.height = "600px";
    } else {
      preview.style.width = "600px";
      preview.style.height = "400px";
    }
  }

  // 2) Read selections
  const selectedBaseColor   = document.getElementById("baseColorPicker").value || "#ffffff";
  const selectedBorderColor = document.getElementById("borderColorPicker").value || "#000000";
  const uploadedLogo        = document.getElementById("logoPicker").value;
  const topText             = document.getElementById("topTextInput").value;
  const bottomText          = document.getElementById("bottomTextInput").value;
  const selectedTextColor   = document.getElementById("textColorPicker").value || "#000000";

  // 3) Apply base / border colors
  const previewEl = document.getElementById("design-preview");
  previewEl.style.backgroundColor = selectedBaseColor;
  previewEl.style.borderColor     = selectedBorderColor;

  // 4) Top/Bottom text
  const topTextElem    = document.getElementById("top-text");
  const bottomTextElem = document.getElementById("bottom-text");
  topTextElem.textContent    = topText;
  bottomTextElem.textContent = bottomText;
  topTextElem.style.setProperty("color", selectedTextColor, "important");
  bottomTextElem.style.setProperty("color", selectedTextColor, "important");
  topTextElem.style.zIndex = "15";
  bottomTextElem.style.zIndex = "15";
  topTextElem.style.pointerEvents = "none";
  bottomTextElem.style.pointerEvents = "none";

  // 5) Inset text based on border choice
  const borderStyleSelect = document.getElementById("borderStylePicker");
  const selectedOption =
    (borderStyleSelect && borderStyleSelect.selectedIndex >= 0)
      ? borderStyleSelect.options[borderStyleSelect.selectedIndex]
      : null;
  const selectedBorderName = selectedOption ? selectedOption.value : "";
  let textInsetPct = 10;
  if (/Default Border (3|4|5)/i.test(selectedBorderName)) {
    textInsetPct = (orientationVal === "vertical") ? 18 : 16;
  }
  topTextElem.style.top = textInsetPct + "%";
  bottomTextElem.style.bottom = textInsetPct + "%";

  // 6) Logo vs placeholder
  const placeholderTextElem = document.getElementById("placeholder-text");
  const logoImgElem         = document.getElementById("uploadedLogo");
  if (uploadedLogo) {
    logoImgElem.src           = uploadedLogo;
    logoImgElem.style.display = "block";
    placeholderTextElem.style.visibility = "hidden";
  } else {
    logoImgElem.style.display = "none";
    placeholderTextElem.style.visibility = "visible";
  }

  // 7) Border preview (color with currentColor)
  const borderContainer = document.getElementById("selectedBorderStyle");

  // Tri-Delta special case
  if (currentOrgKey === "delta-delta-delta" && selectedOption && selectedOption.value === "Default Border") {
    if (orientationVal === "vertical") {
      borderContainer.innerHTML = `
        <img src="https://cdn.shopify.com/s/files/1/0840/7023/6464/files/DDD_Customizer_Border_VERT.svg?v=1743103702"
             style="width:100%; height:100%;" alt="Tri-Delta Border" />
      `;
    } else {
      borderContainer.innerHTML = `
        <img src="https://cdn.shopify.com/s/files/1/0840/7023/6464/files/DDD_Customizer_Border.svg?v=1743094036"
             style="width:100%; height:100%;" alt="Tri-Delta Border" />
      `;
    }
    borderContainer.style.display = "block";
    return;
  }

  // Reset preview by default
  borderContainer.innerHTML = "";
  borderContainer.style.display = "none";

  // Nothing selected? bail.
  if (!selectedOption || !selectedOption.value) return;

  // No SVG URL on the selected option? bail.
  const svgUrl = selectedOption.dataset.svgUrl;
  if (!svgUrl) return;

fetch(svgUrl)
  .then(r => r.text())
  .then(svgText => {
    const chosen = document.getElementById("borderColorPicker").value || "#000000";

    // Parse SVG
    const parser = new DOMParser();
    const doc = parser.parseFromString(svgText, "image/svg+xml");
    const parsedSvg = doc.querySelector("svg");
    if (!parsedSvg) throw new Error("SVG parse failed (no <svg> tag found).");

    // Import into this document (prevents some weirdness across browsers)
    const svg = document.importNode(parsedSvg, true);

    // Ensure viewBox exists (critical for reliable scaling)
    if (!svg.getAttribute("viewBox")) {
      const wAttr = svg.getAttribute("width") || "";
      const hAttr = svg.getAttribute("height") || "";
      const w = parseFloat(wAttr) || 1000;
      const h = parseFloat(hAttr) || 1000;
      svg.setAttribute("viewBox", `0 0 ${w} ${h}`);
    }

    // Size to container
    svg.setAttribute("width", "100%");
    svg.setAttribute("height", "100%");
    svg.style.display = "block";

    const isVertical = (orientationVal === "vertical");

    // Keep it predictable: fit, rotate, then crop overflow at container
    svg.setAttribute("preserveAspectRatio", "xMidYMid meet");

    // Clip overflow so rotation can’t spill outside preview
    borderContainer.style.overflow = "hidden";
    preview.style.overflow = "hidden";

    // Make "currentColor" work everywhere
    svg.style.color = chosen;

    // Rewrite embedded <style> blocks so they don’t fight us
    svg.querySelectorAll("style").forEach(tag => {
      if (!tag.textContent) return;
      tag.textContent = tag.textContent
        .replace(/#(?:ffd628|fcd107|f1c400|ffed6c|ffc600|ffb300|f4bd1d)\b/ig, "currentColor")
        .replace(/#(?:000000|000|010101|1d1d1b|231f20|111111|0f0f0f)\b/ig, "currentColor")
        .replace(/\brgb\(\s*0\s*,\s*0\s*,\s*0\s*(?:,\s*1\s*)?\)/ig, "currentColor")
        .replace(/\bblack\b/ig, "currentColor");
    });

    // Force paint to currentColor (covers attributes + inline styles + many class-based cases)
    const paintables = svg.querySelectorAll("path, rect, polygon, polyline, circle, ellipse, line, g, use, stop");
    paintables.forEach(node => {
      const tag = node.tagName.toLowerCase();

      if (tag === "stop") {
        node.setAttribute("stop-color", "currentColor");
        node.style.setProperty("stop-color", "currentColor", "important");
        return;
      }

      // If it has a stroke/fill at all, force to currentColor
      if (node.getAttribute("stroke") && node.getAttribute("stroke") !== "none") {
        node.setAttribute("stroke", "currentColor");
      }
      if (node.getAttribute("fill") && node.getAttribute("fill") !== "none") {
        node.setAttribute("fill", "currentColor");
      }

      // Also slam inline styles (beats most SVG class styling)
      node.style.setProperty("stroke", "currentColor", "important");
      node.style.setProperty("fill", "currentColor", "important");
    });

    // Render into the container
    borderContainer.innerHTML = "";
    borderContainer.appendChild(svg);
    borderContainer.style.display = "block";

   // Orientation: rotate + dimension swap so the whole border stays in frame
svg.style.position = "absolute";
svg.style.left = "50%";
svg.style.top = "50%";
svg.style.transformOrigin = "50% 50%";

if (isVertical) {
  // Swap dimensions: the rotated SVG needs the preview's height as its width, and vice versa
  const pw = preview.clientWidth;
  const ph = preview.clientHeight;

  svg.style.width = `${ph}px`;
  svg.style.height = `${pw}px`;

  // Center, then rotate
  svg.style.transform = "translate(-50%, -50%) rotate(90deg)";
} else {
  // Normal: match preview
  svg.style.width = "100%";
  svg.style.height = "100%";
  svg.style.transform = "translate(-50%, -50%)";
}
  })
  .catch(err => {
    console.error("Error fetching/processing SVG:", err);
    borderContainer.innerHTML = "";
    borderContainer.style.display = "none";
  });
  } // ✅ closes updatePreview()

/* -------------------------
   Function: setupEventListeners
------------------------- */
function setupEventListeners() {
  console.log("setupEventListeners() called...");
  document.getElementById("baseColorPicker").addEventListener("change", updatePreview);
  document.getElementById("borderColorPicker").addEventListener("change", updatePreview);
  document.getElementById("logoPicker").addEventListener("change", updatePreview);
  document.getElementById("topTextInput").addEventListener("input", updatePreview);
  document.getElementById("bottomTextInput").addEventListener("input", updatePreview);
  document.getElementById("textColorPicker").addEventListener("change", updatePreview);
  document.getElementById("orientationPicker").addEventListener("change", updatePreview);

  document.getElementById("productTypePicker").addEventListener("change", () => {
    updatePriceEstimate();
    syncBuyButton();
  });

  document.getElementById("borderStylePicker").addEventListener("change", updatePreview);
}

/* -------------------------
   Function: updatePriceEstimate
------------------------- */
function updatePriceEstimate() {
  console.log("updatePriceEstimate() called...");
  const priceDisplay = document.getElementById("price-estimate");
  const productType = document.getElementById("productTypePicker").value;

  const productPrices = {
    // Mats:
    "2'x3' Entry Mat": 109.99,
    "3'x4' Entry Mat": 289.99,
    "4'x6' Entry Mat": 459.99,

    // Rugs (leave as 'Varies' to avoid hard-promise on rug pricing):
    "4'x5' Rug": 259.99,
    "5'x8' Rug": 459.99,
    "8'x11' Rug": 859.99,

    "Other": "Varies"
  };

  if (!productType || !(productType in productPrices)) {
    priceDisplay.textContent = "Estimated Total: Select a Product Type";
    return;
  }
  if (productPrices[productType] === "Varies") {
    priceDisplay.textContent = "Estimated Total: Varies (Contact for details)";
  } else {
    const basePrice  = productPrices[productType];
    const discount   = basePrice * 0.15;
    const finalPrice = basePrice - discount;
    priceDisplay.textContent =
      `Estimated Total: $${basePrice.toFixed(2)} - $${discount.toFixed(2)} = $${finalPrice.toFixed(2)} (Before Taxes & Custom Design Fee)`;
  }
}

/* -------------------------
   Helpers: parse selection → (type, size)
------------------------- */
function parseSelectionLabel(label) {
  // Returns {type:'mat'|'rug'|null, size:'2x3'|'3x4'|'4x6'|'4x5'|'5x8'|'8x11'|null}
  if (!label) return { type: null, size: null };
  const matMatch = label.match(/^(\d)'\s?x\s?(\d)'\s? Entry Mat$/i);
  if (matMatch) {
    return { type: 'mat', size: `${matMatch[1]}x${matMatch[2]}` };
  }
  const rugMatch = label.match(/^(\d)'\s?x\s?(\d{1,2})'\s? Rug$/i);
  if (rugMatch) {
    return { type: 'rug', size: `${rugMatch[1]}x${rugMatch[2]}` };
  }
  return { type: null, size: null };
}

/* -------------------------
   Function: buildBuyUrl
------------------------- */
function buildBuyUrl() {
  const selection = document.getElementById("productTypePicker").value;
  const { type, size } = parseSelectionLabel(selection);
  if (!type || !size) return null;

  const baseUrl = (PRODUCT_URLS[type] && PRODUCT_URLS[type][size]) ? PRODUCT_URLS[type][size] : null;
  if (!baseUrl) return null;

  // Build query params for tracking/context
  const params = [];
  if (currentOrgKey) params.push(`org=${encodeURIComponent(currentOrgKey)}`);
  params.push(`size=${encodeURIComponent(selection)}`); // preserve human label
  params.push(`utm_source=customizer`, `utm_medium=cta`, `utm_campaign=${encodeURIComponent(currentOrgKey || "generic")}`);

  return `${baseUrl}?${params.join("&")}`;
}

/* -------------------------
   Function: syncBuyButton (enable/disable + label + href)
------------------------- */
function syncBuyButton() {
  const btn = document.getElementById("buyCustom");
  if (!btn) return;

  const selection = document.getElementById("productTypePicker").value;
  const { type, size } = parseSelectionLabel(selection);
  const url = buildBuyUrl();

  if (!type || !size || !url) {
    btn.href = "#";
    btn.setAttribute("aria-disabled", "true");
    btn.classList.add("btn-disabled");
    btn.textContent = "Buy Custom";
    return;
  }

  const sizeLabel = selection.replace("Entry ", ""); // cosmetic
  const typeLabel = (type === 'mat') ? 'Mat' : 'Rug';

  btn.href = url;
  btn.removeAttribute("aria-disabled");
  btn.classList.remove("btn-disabled");
  btn.textContent = `Buy Custom ${typeLabel} ${sizeLabel}`;
}

/* -------------------------
   Submission event
------------------------- */
document.addEventListener("click", function (e) {
  const submitBtn = document.getElementById("submitDesign");
  if (e.target === submitBtn) {
    console.log("submitDesign clicked...");
    const userName           = document.getElementById("userNameInput").value;
    const userEmail          = document.getElementById("userEmailInput").value;
    const productType        = document.getElementById("productTypePicker").value;
    const selectedBaseColor  = document.getElementById("baseColorPicker").value;
    const selectedBorderColor= document.getElementById("borderColorPicker").value;
    const uploadedLogo       = document.getElementById("logoPicker").value;
    const topText            = document.getElementById("topTextInput").value;
    const bottomText         = document.getElementById("bottomTextInput").value;
    const selectedTextColor  = document.getElementById("textColorPicker").value || "#000000";
    const isVertical         = (document.getElementById("orientationPicker").value === "vertical") ? "Vertical" : "Horizontal";
    const additionalRequests = document.getElementById("additionalRequestsInput").value;

    // 1. Border Style: exact label (e.g. "Default Border 3")
    const borderStyleSelect = document.getElementById("borderStylePicker");
    const selectedBorderOption = borderStyleSelect.selectedOptions[0];
    const selectedBorderName   = selectedBorderOption ? selectedBorderOption.value : "";

    // 2. Chapter (only if this org has chapters defined)
    let chapterPicked = "";
    const orgData = organizations[currentOrgKey];
    if (orgData && Array.isArray(orgData.chapters) && orgData.chapters.length > 0) {
      chapterPicked = document.getElementById("chapterPicker").value || "";
    }

    // 3. Build the prefill URL
    let submissionUrl =
      "https://docs.google.com/forms/d/e/1FAIpQLSdOxd7SofN5no7LrRWjZ3Ehs7qyz8jXGLdiLPn7YgKMYXCMBQ/viewform?usp=pp_url"
      + `&entry.1436079684=${encodeURIComponent(userName)}`
      + `&entry.2093363187=${encodeURIComponent(userEmail)}`
      + `&entry.825667336=${encodeURIComponent(productType)}`
      + `&entry.378756120=${encodeURIComponent(selectedBaseColor)}`
      + `&entry.1830382283=${encodeURIComponent(selectedBorderName)}`
      + `&entry.1986364188=${encodeURIComponent(selectedBorderColor)}`
      + `&entry.1777811819=${encodeURIComponent(uploadedLogo)}`
      + `&entry.292297435=${encodeURIComponent(topText)}`
      + `&entry.10235251=${encodeURIComponent(bottomText)}`
      + `&entry.681710926=${encodeURIComponent(selectedTextColor)}`
      + `&entry.2026361460=${encodeURIComponent(isVertical)}`;

    if (chapterPicked) {
      submissionUrl += `&entry.1222824780=${encodeURIComponent(chapterPicked)}`;
    }

    submissionUrl += `&entry.1120034173=${encodeURIComponent(additionalRequests)}`;

    window.open(submissionUrl, "_blank");
  }
});

/* -------------------------
   Init Customizer
------------------------- */
function init() {
  console.log("init() called. Loading data, setting up listeners, and showing container...");
  loadOrganizationData();
  setupEventListeners();
  updatePreview();
  syncBuyButton();
  document.getElementById("rug-customizer-container").style.display = "block";
}

init();